import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgRamblerMail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0c7.543 0 11.314 0 13.657 2.343S32 8.458 32 16c0 7.543 0 11.314-2.343 13.657S23.543 32 16 32c-7.542 0-11.314 0-13.657-2.343S0 23.543 0 16Z"
      fill="#2F5BF2"
    />
    <rect
      x={5}
      y={8.8}
      width={21}
      height={14}
      rx={0.5}
      fill="url(#RamblerMail_svg__a)"
    />
    <path
      d="m5.217 8.888 9.94 9.388a.5.5 0 0 0 .686 0l9.94-9.388A.498.498 0 0 0 25.5 8.8h-20a.498.498 0 0 0-.283.088Z"
      fill="#fff"
    />
    <path
      d="M14.04.002 3.13 30.319a5.96 5.96 0 0 1-.787-.662C0 27.314 0 23.542 0 16 0 8.457 0 4.686 2.343 2.343 4.474.213 7.786.02 14.041.002Z"
      fill="#649DFF"
    />
    <defs>
      <radialGradient
        id="RamblerMail_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0 13.8 -20.7001 0 15.5 9)"
      >
        <stop stopColor="#B7CCFF" />
        <stop offset={1} stopColor="#D1E2FF" />
      </radialGradient>
    </defs>
  </svg>
);
const Memo = memo(SvgRamblerMail);
export default Memo;
